import React from 'react';
import { formatSaldo } from '../../utils/formatters';

const formatByMoneda = (value, moneda) => formatSaldo(value, moneda);

const palette = {
    deudor: { bg: '#FEE2E2', text: '#991B1B', border: '#FCA5A5' },
    acreedor: { bg: '#D1FAE5', text: '#065F46', border: '#6EE7B7' },
    neutro: { bg: '#F3F4F6', text: '#4B5563', border: '#E5E7EB' },
    sinSnapshot: { bg: '#F9FAFB', text: '#9CA3AF', border: '#E5E7EB' },
};

const pickColor = (saldoProyectado, tieneSnapshot) => {
    if (!tieneSnapshot) return palette.sinSnapshot;
    if (saldoProyectado < -0.005) return palette.deudor;
    if (saldoProyectado > 0.005) return palette.acreedor;
    return palette.neutro;
};

const SaldoClienteBadge = ({ saldoReal, saldoProyectado, moneda, tieneSnapshot, compact = false }) => {
    if (!tieneSnapshot) {
        return (
            <span
                title="Sin snapshot del custodio cargado para hoy"
                style={{
                    display: 'inline-block',
                    padding: compact ? '0.15rem 0.4rem' : '0.25rem 0.5rem',
                    borderRadius: '4px',
                    border: `1px solid ${palette.sinSnapshot.border}`,
                    backgroundColor: palette.sinSnapshot.bg,
                    color: palette.sinSnapshot.text,
                    fontSize: compact ? '0.75rem' : '0.8rem',
                    fontWeight: 500,
                    fontStyle: 'italic',
                }}
            >
                sin snapshot
            </span>
        );
    }

    const colors = pickColor(saldoProyectado, tieneSnapshot);
    const proyectadoLabel = formatByMoneda(saldoProyectado, moneda);
    const realDistinto = Math.abs((saldoReal ?? 0) - (saldoProyectado ?? 0)) > 0.005;
    const realLabel = realDistinto ? formatByMoneda(saldoReal, moneda) : null;

    return (
        <span
            title={realLabel ? `Saldo real: ${realLabel} · Proyectado: ${proyectadoLabel}` : `Saldo proyectado: ${proyectadoLabel}`}
            style={{
                display: 'inline-flex',
                flexDirection: 'column',
                alignItems: 'flex-end',
                padding: compact ? '0.15rem 0.45rem' : '0.3rem 0.55rem',
                borderRadius: '4px',
                border: `1px solid ${colors.border}`,
                backgroundColor: colors.bg,
                color: colors.text,
                fontSize: compact ? '0.78rem' : '0.85rem',
                fontWeight: 700,
                lineHeight: 1.15,
                fontVariantNumeric: 'tabular-nums',
            }}
        >
            <span>{proyectadoLabel}</span>
            {realLabel && (
                <span style={{ fontSize: '0.65rem', fontWeight: 500, opacity: 0.85, fontStyle: 'italic' }}>
                    real: {realLabel}
                </span>
            )}
        </span>
    );
};

export default SaldoClienteBadge;
